class VerificationReceiver {
  constructor(params) {
    this.username = params.Username ? params.Username : params.username;
    this.phoneNumber = params.PhoneNumber ? params.PhoneNumber : params.phoneNumber;
    this.emailAddress = params.EmailAddress ? params.EmailAddress : params.emailAddress;
    this.phoneNumberIsUnknown = params.PhoneNumberIsUnknown ? params.PhoneNumberIsUnknown : params.phoneNumberIsUnknown;
    this.emailAddressIsUnknown = params.EmailAddressIsUnknown
      ? params.EmailAddressIsUnknown
      : params.emailAddressIsUnknown;
    this.isVerificationCodeNeeded = params.IsVerificationCodeNeeded
      ? params.IsVerificationCodeNeeded
      : params.isVerificationCodeNeeded;
    this.sendDate = params.SendDate ? params.SendDate : params.sendDate;
    this.customerNumber = params.CustomerNumber ? params.CustomerNumber : params.customerNumber;
  }
}
export { VerificationReceiver as default };
